/** Shared by the cabinet and the admin console so dates read the same everywhere. */
export function formatPartnerDate(value: string): string {
  return new Intl.DateTimeFormat(undefined, { dateStyle: "medium" }).format(new Date(value))
}
